module.exports = __webpack_public_path__ + "img/READY_DT.2866ac25.png";